import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import 'firebase/storage';
import "firebase/functions";

// Initialize Firebase
const firebaseConfig = {
  apiKey: "AIzaSyAI-gdF0GYR83BuoYNkyfYrfiE5iGzUyoQ",
  authDomain: "call-traffic-data.firebaseapp.com",
  databaseURL: "https://call-traffic-data.firebaseio.com",
  projectId: "call-traffic-data",
  storageBucket: "call-traffic-data.appspot.com",
  messagingSenderId: "212813686175",
  appId: "1:212813686175:web:6554c2840b4d88a04b09aa"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const functions = firebase.functions();

firebaseApp.firestore().settings({});
export default firebaseApp.firestore();
 